export const flexPositions = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
}
